<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn text x-small color="primary" v-on="on" v-bind="attrs">
        Export
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="exportInvoiceBatch('txt')">
        <v-list-item-title>To Text File</v-list-item-title>
      </v-list-item>
      <v-list-item @click="exportInvoiceBatch('csv')">
        <v-list-item-title>To Csv</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { downloadFile } from "../../utils/download-utils";
import { formatDateForFilename } from "../../utils/format-utils";
export default {
  props: ["invoiceBatchId"],
  computed: {
    invoiceBatch() {
      return this.$store.getters["billingModule/getInvoiceBatch"](
        this.invoiceBatchId
      );
    },
    fileName() {
      return `${this.invoiceBatch.program?.code} Invoice Batch #${
        this.invoiceBatchId
      } ${formatDateForFilename(this.invoiceBatch.batchDate)}`;
    },
  },
  methods: {
    async exportInvoiceBatch(fileExtension) {
      this.$store.commit("uxModule/setShowLoader", true);
      var response = await this.$store.dispatch(
        "billingModule/exportInvoiceBatch",
        {
          invoiceBatchId: this.invoiceBatchId,
          fileExtension: fileExtension,
        }
      );
      if (response) {
        await downloadFile(response, `${this.fileName}.${fileExtension}`);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
